import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CascadingMessagesAnalyticsEffects } from './cascading-messages/cascading-messages-analytics.effects';
import { CascadingMessagesStateEffects } from './cascading-messages/cascading-messages-state.effects';
import { HeadlinesAnalyticsEffects } from './headlines/headlines-analytics.effects';
import { HeadlinesStateEffects } from './headlines/headlines-state.effects';
import { HeadlinesModuleStateReducer, InitialHeadlinesModuleState } from './headlines-state';

import { HeadlinesModuleStateKey } from './index';

/**
 * Eager headlines NgRx registration so shared layout (filters-toolbar) can select
 * headlines state before the lazy headlines route loads. Mirrors RockStateModule / TodoStateModule.
 */
@NgModule({
  imports: [
    StoreModule.forFeature(HeadlinesModuleStateKey, HeadlinesModuleStateReducer, {
      initialState: InitialHeadlinesModuleState,
    }),
    EffectsModule.forFeature([
      HeadlinesStateEffects,
      CascadingMessagesStateEffects,
      HeadlinesAnalyticsEffects,
      CascadingMessagesAnalyticsEffects,
    ]),
  ],
})
export class HeadlinesStateModule {}
